import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Segment layout for `/invoices` — listing + invoice detail render through this Outlet. */
export const Route = createFileRoute('/invoices')({
  component: Outlet,
});
